export const currencyDecimals = {
  AED: [784, 2],
  AFN: [971, 2],
  ALL: [8, 2],
  AMD: [51, 2],
  ANG: [532, 2],
  AOA: [973, 2],
  ARS: [32, 2],
  AUD: [36, 2],
  AWG: [533, 2],
  AZN: [944, 2],
  BAM: [977, 2],
  BBD: [52, 2],
  BDT: [50, 2],
  BGN: [975, 2],
  BHD: [48, 3],
  BIF: [108, 0],
  BMD: [60, 2],
  BND: [96, 2],
  BOB: [68, 2],
  BOV: [984, 2],
  BRL: [986, 2],
  BSD: [44, 2],
  BTN: [64, 2],
  BWP: [72, 2],
  BYN: [933, 2],
  BYR: [974, 0],
  BZD: [84, 2],
  CAD: [124, 2],
  CDF: [976, 2],
  CHE: [947, 2],
  CHF: [756, 2],
  CHW: [948, 2],
  CLF: [990, 0],
  CLP: [152, 0],
  CNY: [156, 2],
  COP: [170, 2],
  COU: [970, 2],
  CRC: [188, 2],
  CUC: [931, 2],
  CUP: [192, 2],
  CVE: [132, 2],
  CZK: [203, 2],
  DJF: [262, 0],
  DKK: [208, 2],
  DOP: [214, 2],
  DZD: [12, 2],
  EGP: [818, 2],
  ERN: [232, 2],
  ETB: [230, 2],
  EUR: [978, 2],
  FJD: [242, 2],
  FKP: [238, 2],
  GBP: [826, 2],
  GEL: [981, 2],
  GHS: [936, 2],
  GIP: [292, 2],
  GMD: [270, 2],
  GNF: [324, 0],
  GTQ: [320, 2],
  GYD: [328, 2],
  HKD: [344, 2],
  HNL: [340, 2],
  HRK: [191, 2],
  HTG: [332, 2],
  HUF: [348, 2],
  IDR: [360, 2],
  ILS: [376, 2],
  INR: [356, 2],
  IQD: [368, 3],
  IRR: [364, 2],
  ISK: [352, 0],
  JMD: [388, 2],
  JOD: [400, 3],
  JPY: [392, 0],
  KES: [404, 2],
  KGS: [417, 2],
  KHR: [116, 2],
  KMF: [174, 0],
  KPW: [408, 2],
  KRW: [410, 0],
  KWD: [414, 3],
  KYD: [136, 2],
  KZT: [398, 2],
  LAK: [418, 2],
  LBP: [422, 2],
  LKR: [144, 2],
  LRD: [430, 2],
  LSL: [426, 2],
  LTL: [440, 2],
  LVL: [428, 2],
  LYD: [434, 3],
  MAD: [504, 2],
  MDL: [498, 2],
  MGA: [969, 0],
  MKD: [807, 2],
  MMK: [104, 2],
  MNT: [496, 2],
  MOP: [446, 2],
  MRO: [478, 2],
  MUR: [480, 2],
  MVR: [462, 2],
  MWK: [454, 2],
  MXN: [484, 2],
  MXV: [979, 2],
  MYR: [458, 2],
  MZN: [943, 2],
  NAD: [516, 2],
  NGN: [566, 2],
  NIO: [558, 2],
  NOK: [578, 2],
  NPR: [524, 2],
  NZD: [554, 2],
  OMR: [512, 3],
  PAB: [590, 2],
  PEN: [604, 2],
  PGK: [598, 2],
  PHP: [608, 2],
  PKR: [586, 2],
  PLN: [985, 2],
  PYG: [600, 0],
  QAR: [634, 2],
  RON: [946, 2],
  RSD: [941, 2],
  RUB: [643, 2],
  RWF: [646, 0],
  SAR: [682, 2],
  SBD: [90, 2],
  SCR: [690, 2],
  SDG: [938, 2],
  SEK: [752, 2],
  SGD: [702, 2],
  SHP: [654, 2],
  SLL: [694, 2],
  SOS: [706, 2],
  SRD: [968, 2],
  SSP: [938, 2],
  STD: [678, 2],
  SYP: [760, 2],
  SZL: [748, 2],
  THB: [764, 2],
  TJS: [972, 2],
  TMT: [795, 2],
  TND: [788, 3],
  TOP: [776, 2],
  TRY: [949, 2],
  TTD: [780, 2],
  TWD: [901, 2],
  TZS: [834, 2],
  UAH: [980, 2],
  UGX: [800, 2],
  USD: [840, 2],
  USN: [997, 2],
  USS: [998, 2],
  UYU: [858, 2],
  UZS: [860, 2],
  VEF: [937, 2],
  VND: [704, 2],
  VUV: [548, 0],
  WST: [882, 2],
  XAF: [950, 0],
  XCD: [951, 2],
  XOF: [952, 0],
  XPF: [953, 0],
  YER: [886, 2],
  ZAR: [710, 2],
  ZMW: [894, 2],
  ZWL: [932, 2]
}
export const currencyCodes = {
  104: 'MMK',
  108: 'BIF',
  116: 'KHR',
  124: 'CAD',
  12: 'DZD',
  132: 'CVE',
  136: 'KYD',
  144: 'LKR',
  152: 'CLP',
  156: 'CNY',
  170: 'COP',
  174: 'KMF',
  188: 'CRC',
  191: 'HRK',
  192: 'CUP',
  203: 'CZK',
  208: 'DKK',
  214: 'DOP',
  230: 'ETB',
  232: 'ERN',
  238: 'FKP',
  242: 'FJD',
  262: 'DJF',
  270: 'GMD',
  292: 'GIP',
  320: 'GTQ',
  324: 'GNF',
  328: 'GYD',
  32: 'ARS',
  332: 'HTG',
  340: 'HNL',
  344: 'HKD',
  348: 'HUF',
  352: 'ISK',
  356: 'INR',
  360: 'IDR',
  364: 'IRR',
  368: 'IQD',
  36: 'AUD',
  376: 'ILS',
  388: 'JMD',
  392: 'JPY',
  398: 'KZT',
  400: 'JOD',
  404: 'KES',
  408: 'KPW',
  410: 'KRW',
  414: 'KWD',
  417: 'KGS',
  418: 'LAK',
  422: 'LBP',
  426: 'LSL',
  428: 'LVL',
  430: 'LRD',
  434: 'LYD',
  440: 'LTL',
  446: 'MOP',
  44: 'BSD',
  454: 'MWK',
  458: 'MYR',
  462: 'MVR',
  478: 'MRO',
  480: 'MUR',
  484: 'MXN',
  48: 'BHD',
  496: 'MNT',
  498: 'MDL',
  504: 'MAD',
  50: 'BDT',
  512: 'OMR',
  516: 'NAD',
  51: 'AMD',
  524: 'NPR',
  52: 'BBD',
  532: 'ANG',
  533: 'AWG',
  548: 'VUV',
  554: 'NZD',
  558: 'NIO',
  566: 'NGN',
  578: 'NOK',
  586: 'PKR',
  590: 'PAB',
  598: 'PGK',
  600: 'PYG',
  604: 'PEN',
  608: 'PHP',
  60: 'BMD',
  634: 'QAR',
  643: 'RUB',
  646: 'RWF',
  64: 'BTN',
  654: 'SHP',
  678: 'STD',
  682: 'SAR',
  68: 'BOB',
  690: 'SCR',
  694: 'SLL',
  702: 'SGD',
  704: 'VND',
  706: 'SOS',
  710: 'ZAR',
  72: 'BWP',
  748: 'SZL',
  752: 'SEK',
  756: 'CHF',
  760: 'SYP',
  764: 'THB',
  776: 'TOP',
  780: 'TTD',
  784: 'AED',
  788: 'TND',
  795: 'TMT',
  800: 'UGX',
  807: 'MKD',
  818: 'EGP',
  826: 'GBP',
  834: 'TZS',
  840: 'USD',
  84: 'BZD',
  858: 'UYU',
  860: 'UZS',
  937: 'VEF',
  882: 'WST',
  886: 'YER',
  894: 'ZMW',
  8: 'ALL',
  901: 'TWD',
  90: 'SBD',
  931: 'CUC',
  932: 'ZWL',
  933: 'BYN',
  936: 'GHS',
  938: 'SDG',
  // 938: 'SSP',
  941: 'RSD',
  943: 'MZN',
  944: 'AZN',
  946: 'RON',
  947: 'CHE',
  948: 'CHW',
  949: 'TRY',
  950: 'XAF',
  951: 'XCD',
  952: 'XOF',
  953: 'XPF',
  968: 'SRD',
  969: 'MGA',
  96: 'BND',
  970: 'COU',
  971: 'AFN',
  972: 'TJS',
  973: 'AOA',
  974: 'BYR',
  975: 'BGN',
  976: 'CDF',
  977: 'BAM',
  978: 'EUR',
  979: 'MXV',
  980: 'UAH',
  981: 'GEL',
  984: 'BOV',
  985: 'PLN',
  986: 'BRL',
  990: 'CLF',
  997: 'USN',
  998: 'USS'
}

export const resolveCurrencyCode = (currency) => {
  if (!currency && currency !== 0) return ''
  if (typeof currency === 'string' && /^[A-Z]{3}$/.test(currency)) return currency

  const normalizedCurrency = /^\d+$/.test(String(currency)) ? Number(currency) : currency

  return currencyCodes[normalizedCurrency] || currency
}
